<template>
  <v-dialog class="confirm-dialog" @input="change" value="true" :persistent="persistent" eager :max-width="maxWidth">
    <v-card :class="dialogWrapperClasses" tile>
      <v-toolbar v-if="Boolean(title)" :color="color" dense flat :style="{ color: titleColor }">
        <v-icon v-if="Boolean(icon)" :color="titleColor" left>{{ icon }}</v-icon>
        <v-toolbar-title class="mt-1 text-subtitle-1 font-weight-bold" v-text="title" />
      </v-toolbar>
      <v-card-text class="confirm-dialog__body body-1 text-body-1 py-3" v-html="message" />
      <v-divider />
      <v-card-actions>
        <v-btn v-if="enableButtonFalse" v-bind="buttonFalseAttrs" @click="choose(false)" data-cy="confirm-dialog--no">
          {{ buttonFalseText || textNo }}
        </v-btn>
        <v-spacer />
        <v-btn v-if="enableButtonTrue" v-bind="buttonTrueAttrs" @click="choose(true)" data-cy="confirm-dialog--yes">
          {{ buttonTrueText || textYes }}
        </v-btn>
        <v-spacer v-if="centerButtonTrue" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="js">
import i18n from "../../i18n";

export default {
  props: {
    maxWidth: {
      type: Number,
      default: null,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    enableButtonTrue: {
      type: Boolean,
      default: true,
    },
    buttonTrueText: {
      type: String,
      default: "",
    },
    enableButtonFalse: {
      type: Boolean,
      default: true,
    },
    buttonFalseText: {
      type: String,
      default: "",
    },
    highlightButtonTrue: {
      type: Boolean,
      default: true,
    },
    centerButtonTrue: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "tertiary",
    },
    icon: {
      type: String,
      default () {
        return this.$vuetify.icons.values.warning;
      },
    },
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    titleColor: {
      type: String,
      default: "#281B41",
    },
    theme: {
      type: String,
      default: "none", // "none" to not apply any theme, "light" or "dark" to force a specific theme
    },
  },
  data () {
    return {
      value: false,
    }
  },
  computed: {
    textYes () {
      return i18n.t("yes");
    },
    textNo () {
      return i18n.t("no");
    },
    buttonFalseAttrs () {
      return {
        class: "btn-false grey--text text--darken-1",
        text: true,
      };
    },
    buttonTrueAttrs () {
      if (this.highlightButtonTrue) {
        return {
          class: "btn-true --highlighted font-weight-bold",
          color: "tertiary primary--text",
          depressed: true,
        }
      }

      return {
        class: "btn-true",
        color: "primary",
        text: true,
      }
    },
    dialogWrapperClasses () {
      return {
        "dialog-wrapper": true,
        "--dark": this.theme === "dark",
        "--light": this.theme === "light",
      }
    },
  },
  methods: {
    choose (value) {
      this.$emit("result", value);
      this.value = value;
      this.$destroy();
    },
    change () {
      this.$destroy();
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-dialog__body::v-deep b {
  color: #281b41;
}

.confirm-dialog__body::v-deep .--red {
  color: #dd2222;
}

.dialog-wrapper {
  &.--light {
    .confirm-dialog__body {
      background: #fff;
      color: #2e3338;
    }
    .v-divider {
      background: #e1e1e1;
    }
    .v-card__actions {
      background: #fff;
    }

    .btn-true.--highlighted {
      background: var(--c-accent-strong) !important;
      color: #fff !important;
    }
  }
}
</style>
